import { gql, useQuery } from '@apollo/client';
import type { Any } from '@livecontrol/core-utils';
import _ from 'lodash';
import { useMemo } from 'react';
import type {
  GetAssetQuery,
  GetAssetQueryVariables,
  GetLocationQuery,
  GetLocationQueryVariables
// eslint-disable-next-line import/no-internal-modules
} from './__generated__/use-untitled-event';

export const QUERY = gql`
query GetAsset(
  $assetId: Int!
) {
  getAsset(assetId: $assetId) {
    id
    manual_client_id
    created_at
    updated_at
    title
    description
    scheduled_time
    scheduled_end
    scheduled_event_id
    scheduled_event_password
    hidden
    was_ever_public
    mux_asset_id
    mux_playback_id
    mux_static_rendition_status
    mux_status
    is_live
    origin
    stream {
      id
      created_at
      updated_at
      client_id
      location_id
      mux_stream_id
    }
    stream_url
    download_url
    thumbnail_url
    archive_video_url
    duration
    stream_urls
  }
}
`;

const QUERY_LOCATIONS = gql`
query LocationsQuery ($location: SearchLocationInput) {
  getLocation(location: $location) {
    user {
      support_notes
      notes
      organization_name
    }
    name
  }
}
`;

export type UntitledEvent =  Exclude<
Exclude<GetAssetQuery['getAsset'], undefined>,
undefined
> & {
  location: GetLocationQuery['getLocation'];
};

export const vars: Any = {
  value: {}
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useUntitledEvent = (assetId: string) => {
  const { data, loading } = useQuery<
    GetAssetQuery,
    GetAssetQueryVariables
  >(QUERY, {
    variables: {
      assetId: Number(assetId)
    }
  });

  const location = useQuery<
    GetLocationQuery,
    GetLocationQueryVariables
  >(QUERY_LOCATIONS, {
    variables: {
      location: {
        id: data?.getAsset?.stream?.location_id ?? ''
      }
    },
    skip: !data?.getAsset?.stream?.location_id
  });

  const value = useMemo((): UntitledEvent | undefined => {
    if (!assetId || !data?.getAsset) {
      return undefined;
    }

    return {
      ...data.getAsset,
      location: location.data?.getLocation
    };
  }, [data?.getAsset, assetId, location.data?.getLocation]);

  return { untitledEvent: value, loading };
};
